import React from 'react'
import PropTypes from 'prop-types'
import BaseIcon from '../../BaseIcon/BaseIcon'
import { ReactComponent as xTwitterIcon } from './x-twitter.svg'

const SquareXTwitter = ({ className }) => {
	return <BaseIcon component={xTwitterIcon} className={className} viewBox="0 0 448 512" />
}

SquareXTwitter.propTypes = {
	className: PropTypes.string,
}

export default SquareXTwitter
